const Overview = ({ disc }) => {
    return <div dangerouslySetInnerHTML={{ __html: disc }} className="overview-container" />;
};

export default Overview;
